function stableHash(value: string) {
  let hash = 0
  for (let index = 0; index < value.length; index += 1) {
    hash = ((hash << 5) - hash + value.charCodeAt(index)) | 0
  }
  return Math.abs(hash)
}

function clamp(value: number, min: number, max: number) {
  return Math.min(max, Math.max(min, value))
}

function toHsl(hue: number, saturation: number, lightness: number) {
  return `hsl(${Math.round(hue)} ${Math.round(saturation)}% ${Math.round(lightness)}%)`
}

export function getClassroomPaletteSeed(input: {
  id?: string | null
  title?: string | null
  icon?: string | null
}) {
  return input.id || input.title || input.icon || 'classroom'
}

export function getClassroomPalette(input: {
  id?: string | null
  title?: string | null
  icon?: string | null
}) {
  const seed = getClassroomPaletteSeed(input)
  const initial = getClassInitial(input.title || seed)
  const hash = stableHash(seed)
  const initialCode = initial.charCodeAt(0)

  // Make the first letter the primary source of hue so different initials
  // are much less likely to collide, then add a tiny stable offset so titles
  // sharing the same initial do not all look identical.
  const baseHue = ((initialCode * 17) + (hash % 11) * 7) % 360
  const lightSaturation = clamp(58 + (hash % 7) * 2, 56, 72)
  const lightLightness = clamp(83 - (hash % 5) * 2, 72, 84)
  const darkSaturation = clamp(42 + (hash % 9), 38, 54)
  const darkLightness = clamp(24 + (hash % 6), 21, 31)

  return {
    light: toHsl(baseHue, lightSaturation, lightLightness),
    dark: toHsl(baseHue, darkSaturation, darkLightness),
  }
}

export function getClassInitial(title: string) {
  const firstChar = title.trim().charAt(0)
  return firstChar ? firstChar.toUpperCase() : 'C'
}
